/**
 * コンサルタントが条件相談操作を可能か判定する
 * NOTE: 判定条件が変わった場合に変更しやすいよう関数化してます
 * @param isProposalTodo
 */
export const getIsNegotiateDisabled = (isProposalTodo) => 
// 提案意向ありでない場合、条件相談させない
!isProposalTodo;
